import { observer } from 'mobx-react';
import icons from '@icons';
import { Picture } from '@ui';
import { Link } from '@compat/router';
import './index.scss';
import type { FC } from 'react';
import { useStores } from '@root/src/stores';

const {
  person: { black: personBlackFilled }
} = icons.Fill;
const {
  crab: { white: crabWhiteOutlined }
} = icons.Outline;

const HeaderAvatar: FC = observer(() => {
  const { userStore, modalsStore } = useStores();
  const { changeAuthModalState } = modalsStore;
  const { isUserLoggedIn, user, notCheckedNotificationsAmount } = userStore;

  return (
    <div className='avatar-wrapper'>
      {isUserLoggedIn ? (
        <Link
          to='/cabinet'
          className={`header-avatar${
            user?.mainImage ? ' header-avatar--no-bg' : ''
          }`}
        >
          {notCheckedNotificationsAmount !== null &&
            notCheckedNotificationsAmount > 0 && (
              <div className='header-avatar__notify-count'>
                {notCheckedNotificationsAmount}
              </div>
            )}
          {user?.mainImage ? (
            <img
              className='header-avatar__img'
              src={user?.mainImage}
              alt='Аватар'
            />
          ) : user?.fio ? (
            <div className='header-avatar__user-fio-avatar'>{user.fio[0]}</div>
          ) : (
            <Picture
              icon={crabWhiteOutlined}
              width='16'
              height={'16'}
              alt='Краб'
            />
          )}
        </Link>
      ) : (
        <div className={'header-avatar header-avatar--white-bg'}>
          <Picture
            onClick={changeAuthModalState}
            icon={personBlackFilled}
            width='24'
            height={'24'}
            alt='Вход'
          />
        </div>
      )}
    </div>
  );
});

export default HeaderAvatar;
